// src/records/ManagerDashboard.js

import {Map, Record, List} from 'immutable';

/**
 * @type {Record}
 */
export default Record({
  /**
   * @deprecated dash v1
   */
  userInfo: null,
  /**
   * @deprecated dash v1
   */
  managerInfo: null,
  /**
   * @deprecated dash v1
   */
  search: {},
  /**
   * @deprecated dash v1
   */
  widgetsCache: null,
  /**
   * @deprecated dash v1
   */
  shouldResetSearch: true,
  /**
   * @deprecated dash v1
   */
  firstLoad: true,

  /* ***************************************************************************
   * ***************************** DASH 2.0 BELOW ******************************
   * **************************************************************************/

  widgets: Map(),
  /**
   * Load the widget for manager level rather than exec, and use this manager id.
   * @deprecated - consider rewriting if your widget depends on this -
   * leads to bad assumptions
   */
  managerId: null,
  widgetConfig: Map(),
  widgetState: Map(),
  hasShownDashv2Loader: false,
  hasRenderedDashv2Gif: false,
});

const ConversationTimelineExtra = Record({
  selectedSearchFieldId: null,
  colorList: List(),
});

export {ConversationTimelineExtra};
